import { useEffect, useState } from "react";
import { _LoanLine } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { Alert } from "../../../../../../modules/theme/Component/Alert";
import { Modal } from "../../../../../../modules/theme/Component/Modal";
import { _BusinessProcess, _CreditOpening, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { FileService } from "../../../../../../core/services/FileService";
import { MASK_BOOLEAN } from "../../../../../../modules/theme/Component/BasicTable";
import { useNavigate } from "react-router-dom";
import { ObjectDinamicViewer } from "../../../../../../modules/contract/etapa-contrato/contrac/ublinvoice/FireElectronicDocument/ObjectDinamicViewer/ObjectDinamicViewer";

export const LoanLineCredits = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_LoanLine);
    const open = useDataBean(_CreditOpening);
    const fileService = new FileService();
    const navigate = useNavigate();

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalInfo, setModalInfo] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        getCredit();
        getCreditOpening();
    }, [])


    const getCredit = () => {

        instance.getLoanLinesByAffiliate(_single.getAffiliate().IDCreditAffiliate).then((data: any) => {
            if (data) {
                setLista(data);
            } else {
                setLista([]);
            }
        }).catch((error: any) => {
            console.log(error);
        })
    }

    const getCreditOpening = () => {
        open.instance.getCreditOpeningToday(_single.getAccountID()).then((data: any) => {
            if (data) {
                open.setLista(data);
            } else {
                open.setLista([]);
            }
        }).catch((error: any) => {
            console.log(error);
        })
    }

    const setAndOpenInfo = (line: any) => {
        setBean(line);
        setModalInfo({ ...modalInfo, view: true, name: `Información de crédito de ${line.Name}` });
    };

    const openCreditsModal = (opneCred) => {
        setModal({ ...modal, view: false });

        // const rules = opneCred?.JSONProps ? JSON.parse(opneCred.JSONProps) : [];
        // const x = opneCred?.JSONLoans ? JSON.parse(opneCred.JSONLoans) : [];

        _single.setSessionItem("OpenCredit", JSON.stringify(opneCred));

        navigate(`/portal/home/credits-loans`)

        // setListOpens(x);
        // setModalOpen({
        //     ...modalOpen,
        //     view: true,
        //     name: `Líneas de crédito de la campaña ${opneCred?.Name}`,
        //     rules: rules
        // });
    };

    const head = [
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Destino del Credito', property: 'LoanDestinationName', visible: true },
        { title: 'Porcentaje de Cuota', property: 'CurrentPercentInterest', visible: true },
        { title: 'Porcentaje de Cuota expirada', property: 'ExpiredPercentInterest', visible: true },
        { title: 'Rangos de Cuotas Disponibles', property: 'QuotaRange', visible: true },
        { title: 'Requiere Codeudor', property: 'RequiresCodebtor', visible: true, mask: MASK_BOOLEAN },
    ]

    return (
        <div className="row">
            <div className="col-md-12 mb-4">
                <div className="h4">Apertura de Crédito</div>
                <div style={{ overflowX: 'auto' }}>
                    <div className="d-flex flex-nowrap">
                        {open.lista.length === 0 ? (
                            <div className="text-center w-100">
                                <Alert clase="info" children={"No hay créditos disponibles"} />
                            </div>
                        ) : (
                            open.lista.map((item: any, index: number) => {
                                const props = item.DataBeanProperties;
                                const img = JSON.parse(item.DataBeanProperties.BanerImage) ?? {};

                                return (
                                    <div className="col-md-6 me-3 flex-shrink-0" key={index} style={{ minWidth: '300px' }} onClick={() => { open.setBean(props) }}>
                                        <div className="card explore-box card-animate rounded h-100" style={{ maxHeight: '200px', overflow: 'hidden' }}>
                                            <div className="explore-place-bid-img position-relative">
                                                <img
                                                    src={img.Media ? `${fileService.getUrlFile(img.MediaContext, img.Media)}` : "./assets/images/no-results.png"}
                                                    alt=""
                                                    className="img-fluid card-img-top explore-img"
                                                    style={{ height: '100px', objectFit: 'cover' }}
                                                />
                                                <div className="bg-overlay"></div>
                                                <div className="place-bid-btn position-absolute bottom-0 end-0 m-2">
                                                    <a
                                                        onClick={() => {
                                                            openCreditsModal(props);
                                                        }}
                                                        className="btn btn-success btn-sm"
                                                    >
                                                        <i className="ri-auction-fill align-bottom me-1"></i> Ver Más
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="card-body p-2">
                                                <h6 className="mb-1 text-truncate">{props.Name}</h6>
                                                <p className="text-muted mb-0 small text-truncate">{props.Description ?? "Crédito disponible"}</p>
                                            </div>
                                            <div className="card-footer border-top border-top-dashed p-2">
                                                <div className="d-flex justify-content-between small">
                                                    <span>Abierto: {props.FromDate}</span>
                                                    <span>Hasta: {props.UptoDate}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            </div>

            <div className="col-md-12">
                <div className="h4">Opciones de Crédito por Caja Nominadora</div>
            </div>
            {lista.length === 0 ?
                (<div className="col-md-12 text-center">
                    <Alert clase="info" children={"No hay lineas de creditos Disponibles"} />
                </div>)
                :
                (
                    lista.map((item: any, index: number) => {

                        const props = item.DataBeanProperties;

                        return (
                            <div className="col-md-6" key={index}>
                                <div className="card">
                                    <div className="card-body p-0">
                                        <div className="alert alert-info border-0 rounded-top rounded-0 m-0 d-flex align-items-center" role="alert">
                                            <div className="flex-grow-1 text-truncate">
                                                <b>{props.Name}</b>
                                            </div>
                                            <div className="flex-shrink-0">
                                                <a onClick={() => { setAndOpenInfo(props) }} className="text-reset text-decoration-underline pointer"><b>Mas Información</b></a>
                                            </div>
                                        </div>

                                        <div className="row align-items-end">
                                            <div className="col-sm-12">
                                                <div className="p-3">
                                                    <p dangerouslySetInnerHTML={{ __html: props.Description }}></p>

                                                    {/* <div className="mt-3">
                                                        <a onClick={() => { setAndOpen(props) }} className="btn btn-success">¡Solicitar Ya!</a>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="px-3">
                                                    <img src="assets/images/user-illustarator-2.png" className="img-fluid" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                )
            }

            <div className="col-md-12">
                <Modal modal={modalInfo} updateModal={setModalInfo} >
                    <ObjectDinamicViewer data={bean} head={head} columns={1} />
                </Modal>
            </div>
        </div>
    )
}